<script setup lang="ts">
import type { NuxtLinkProps } from "#app"

defineProps<{
  to: string
  showBadge?: boolean
  disableActiveIndicator?: boolean
  target?: NuxtLinkProps["target"]
}>()
</script>
<template>
  <div class="relative">
    <div v-if="showBadge" class="absolute mx-1 my-1.5">
      <div class="absolute size-1 animate-ping rounded-full bg-red-500" />
      <div class="size-1 rounded-full bg-red-500" />
    </div>
    <NuxtLink
      v-slot="slots"
      :target
      class="flex w-full items-center gap-3 rounded-lg px-2 py-2.5 text-left text-base/6 font-medium text-zinc-950 transition-all hover:bg-zinc-950/5 *:data-[slot=icon]:size-6 *:data-[slot=icon]:shrink-0 *:data-[slot=icon]:text-zinc-500 hover:*:data-[slot=icon]:text-zinc-950 sm:py-2 sm:text-sm/5 sm:*:data-[slot=icon]:size-5"
      :active-class="
        !disableActiveIndicator ? '*:data-[slot=icon]:text-zinc-950' : ''
      "
      type="button"
      :to
    >
      <slot />
      <span
        v-if="slots?.isActive && !disableActiveIndicator"
        class="absolute inset-y-2 -left-1.5 w-0.5 rounded-full bg-zinc-950 @[12rem]/navigation:-left-3"
      />
    </NuxtLink>
  </div>
</template>
